import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LOOKUP from 'constants/lookup';
import { getPriceMatrices } from 'actions/EntityActions';
import { priceMatrixListCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
// Basic Components
import Button from 'screens/components/basic/Button';
import Panel from 'screens/components/basic/Panel';
import GenericTable from 'screens/components/advanced/GenericTable';
import Grid from 'screens/components/basic/Grid';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

class PriceMatrixList extends Component {
    constructor(props, context) {
        super(props, context);

        this.url = "/priceMatrix/";
    }

    componentWillMount() {
        this.props.getPriceMatrices();
    }

    redirectToAddPriceMatrix = () => {
        this.props.navigate(this.url + "add");
    }

    redirectToEditPriceMatrix = (id) => {
        this.props.navigate(this.url + `edit/${id}`);
    }

    render() {
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.menu.inventory.items.priceMatrix.text}</li>
                </ol>
                <h2>{LOOKUP.menu.inventory.items.priceMatrix.text}</h2>
            </div>);

        const sideContent = (
            <Panel title="Toolbox">
                <div className="row text-center">
                    <Button type="AddButton"
                        className="toolbox-button"
                        label={LOOKUP.priceMatrix.controls.addNewButton}
                        onTouchTap={() => this.redirectToAddPriceMatrix()} />
                </div>
            </Panel>
        );

        const listPriceMatrix = (this.props.priceMatrices || []).map((item) => {
            return {
                Id: (<Link className="edit-link" to={this.url + `edit/${item.id}`}>{item.id}</Link>),
                Name: (<Link to={this.url + `edit/${item.id}`}>{item.name}</Link>),
                NumberOfProducts: item.numberOfProducts,
                Status: (item.status == 'Active' ? <p className="statusIconGreen m-0">Active</p> :
                <p className="statusIconRed m-0">Inactive</p>),
                Icons: (
                    <div>
                        <Button
                            type="IconEditButton"
                            mini={true}
                            onTouchTap={() => this.redirectToEditPriceMatrix(item.id)} />
                    </div>
                )
            };
        });

        return (
            <Grid headerContent={priceMatrixListCrumb}>
                <PageHeaderWithButton title={LOOKUP.menu.inventory.items.priceMatrix.text}>
                    <Button
                        type="AddButton"
                        mini={true}
                        className="bg-light-green"
                        label={LOOKUP.priceMatrix.controls.addNewButton}
                        onTouchTap={() => this.redirectToAddPriceMatrix()}
                    />
                </PageHeaderWithButton>
                <GenericTable
                    className="table_center tableHeaderwhiteColorFont"
                    tableBodyClassName="price-matrix-table"
                    multiSelectable={false}
                    enableSelectAll={false}
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    displayRowCheckbox={false}
                    selectable={false}
                    stripedRows={true}
                    columns={LOOKUP.priceMatrix.tableColumns}
                    rows={listPriceMatrix} />
            </Grid>
        );
    }
}


function mapStateToProps(state) {
    return {
        priceMatrices: state.entity.priceMatricesList
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPriceMatrices: () => dispatch(getPriceMatrices())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(PriceMatrixList));